import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import { AuthContext } from '../../../../contexts/AuthContext';
import {
  Modules,
  AuthRoutes,
  RouteParamsTypes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../../../../enums';
import { hasResourseAccess } from '../../../../utils/methods';

interface HeaderProps {
  id?: string;
  view: boolean;
  edit: boolean;
}

const Header: React.FC<HeaderProps> = ({ id, view, edit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.Add] }],
  });
  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.Update] }],
  });
  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.View] }],
  });

  const handleGoToListClick = (e?: any) => {
    const url = Modules.developers + AuthRoutes.developers;
    if (e && (e.ctrlKey || e.metaKey)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  const handleEditButtonClick = (e?: any) => {
    const url = `${Modules.developers}${AuthRoutes.developers}${RouteParamsTypes.edit}/${id}`;
    if (e && (e.ctrlKey || e.metaKey)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  const handleAddNewClick = (e?: any) => {
    const url = Modules.developers + AuthRoutes.developers + RouteParamsTypes.add;
    if (e && (e.ctrlKey || e.metaKey)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('developers.addEdit.pageTexts.header.title')}</h4>
        <p>{t('developers.addEdit.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        <div>
          {edit && hasAddAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light me-3"
              text={t('developers.addEdit.pageTexts.header.addNew')}
              onClick={handleAddNewClick}
            />
          )}

          {view && hasEditAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light me-3"
              text={t('developers.addEdit.pageTexts.header.editBtn')}
              onClick={(e) => handleEditButtonClick(e)}
            />
          )}

          {hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light"
              onClick={handleGoToListClick}
              text={t('developers.addEdit.pageTexts.header.goToList')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
